var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable, computed } from 'mobx';
import { default as seededshuffle } from 'seededshuffle';
import { Actor } from '../../../classes/actor/Actor';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { withDefault } from '../../../utils/serializr/schema/middle/withDefault';
import { list } from '../../../utils/serializr/schema/list';
import { object } from '../../../utils/serializr/schema/object';
import { deserialize } from '../../../utils/serializr/core/deserialize';
import { SelectOption } from '../SelectOption/SelectOption';
import { SelectTaskEval } from './modules/SelectTaskEval';
import { SelectTaskProgress } from './modules/SelectTaskProgress';
import { SelectTaskUI } from './modules/SelectTaskUI';
export class SelectTask extends Actor {
    type = 'selecttask';
    options = observable.array();
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get exportingChildren() {
        return [...super.exportingChildren, ...this.options]; // importing nodes
    }
    get question() {
        return this.parent;
    }
    get itemIndex() {
        return this.question.selectTasks.indexOf(this);
    }
    get itemNumber() {
        return this.itemIndex + 1;
    }
    get isActiveSelectTask() {
        return true;
    }
    get shuffledOptions() {
        if (!this.question.shouldShuffle) {
            return this.options;
        }
        return seededshuffle.shuffle(this.options, this.question.shuffleSeed, true);
    }
    get hoveringOption() {
        return this.options.find(option => option.actorInteract.isActorHovering);
    }
    get correctOption() {
        return this.options.find(option => option.shouldBeSelected);
    }
    get taskEval() {
        return new SelectTaskEval(this);
    }
    get taskProgress() {
        return new SelectTaskProgress(this);
    }
    get taskUI() {
        return new SelectTaskUI(this);
    }
    static fromSerialized(json = {}) {
        return deserialize(SelectTask, json);
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {
                options: withDefault(list(object(SelectOption)), []),
            },
        };
    }
}
__decorate([
    observable.shallow
], SelectTask.prototype, "options", void 0);
__decorate([
    computed
], SelectTask.prototype, "shuffledOptions", null);
__decorate([
    memoize
], SelectTask.prototype, "taskEval", null);
__decorate([
    memoize
], SelectTask.prototype, "taskProgress", null);
__decorate([
    memoize
], SelectTask.prototype, "taskUI", null);
__decorate([
    memoize
], SelectTask, "serializeInfo", null);
